import { Fragment, useEffect, useState, useCallback, useRef } from 'react';
import api from '../../services/api';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import $ from 'jquery';
import CurrencyInput from 'react-currency-masked-input';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import pt from 'date-fns/locale/pt';
import 'moment-timezone';
import * as moment from 'moment-timezone';
import Spinner from 'react-bootstrap/Spinner';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as xlsx from 'xlsx/xlsx.mjs';
import * as cpexcel from 'xlsx/dist/cpexcel.full.mjs';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeView from '@material-ui/lab/TreeView';
import { toast } from 'react-toastify';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { ImportTab } from '../../components/AlteraPreco/ImportTab';
import { HistoryImportTab } from '../../components/AlteraPreco/HistoryImportTab';
import { useLoading } from '../../hooks/useLoading';

registerLocale('pt', pt);
xlsx.set_cptable(cpexcel);

var currentProduto = null;
var currentCluster = null;
var respMsg = '';
var jsonPlanilha = {};

const token = JSON.parse(localStorage.getItem('token'));

function ShowAlert(title, message) {
  $('#modal-alert .modal-title').html(title);
  $('#modal-alert .modal-body').html(message);
  window.$('#modal-alert').modal('show');
}

export function AlteraPrecoBeta() {
  const [produtosRelacionados, setProdutosRelacionados] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [precosRelatorio, setPrecosRelatorio] = useState([]);
  const [importacaoData, setImportacaoData] = useState([]);
  const [produtoNaoMonitoradoList, setProdutoNaoMonitoradoList] = useState([])
  const [locais, setLocais] = useState([]);
  const [segmentos, setSegmentos] = useState([]);
  const [embalagens, setEmbalagens] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const hiddenFileInput = useRef(null);
  const [dtaAgendamento, setDtaAgendamento] = useState(new Date());
  const [selectedSegments, setSelectedSegments] = useState([]);
  const [isExportingCSV, setIsExportingCSV] = useState(false)
  const [currentBatchId, setCurrentBatchId] = useState(null)

  const loading = useLoading()

  useEffect(() => {
    async function fetchData() {
      const res = await api.get('/empresa/v1/segmento');
      if (res.data != null) {
        setSegmentos(res.data.results);
      }
    }

    $('.card-embalagem').hide();
    $('.card-relacionados').hide();
    $('#boxEmpresas3').hide();
    $('#boxSegmentos2').hide();
    fetchData();
    BuscaEmpresas();
    BuscaClusters();

    $('.segmento-inverter').change(function () {
      $('.segmento-todos').prop('checked', false);
      for (var i = 0; i < $('.segmento-preco').length; i++) {
        if ($('.segmento-preco').eq(i).prop('checked') == true) {
          $('.segmento-preco').eq(i).prop('checked', false);
        } else {
          $('.segmento-preco').eq(i).prop('checked', true);
        }
      }
    });

    $('.empresas-filtro-inverter').change(function () {
      for (var i = 0; i < $('.empresas-filtro').length; i++) {
        if ($('.empresas-filtro').eq(i).prop('checked') == true) {
          $('.empresas-filtro').eq(i).prop('checked', false);
        } else {
          $('.empresas-filtro').eq(i).prop('checked', true);
        }
      }
    });

    $('.segmentos-filtro-inverter').change(function () {
      for (var i = 0; i < $('.segmentos-filtro').length; i++) {
        if ($('.segmentos-filtro').eq(i).prop('checked') == true) {
          $('.segmentos-filtro').eq(i).prop('checked', false);
        } else {
          $('.segmentos-filtro').eq(i).prop('checked', true);
        }
      }
    });
  }, []);

  $(document).ready(function () {
    $('.segmento-todos').change(function () {
      $('.segmento-inverter').prop('checked', false);
      if (this.checked) {
        $('.segmento-preco').prop('checked', true);
      } else {
        $('.segmento-preco').prop('checked', false);
      }
    });

    $('.local-todos').prop('checked', true);
    $('.local').prop('checked', true);
    $('.local').change(function () {
      $('#ddlCluster option').eq(0).prop('selected', true);
      if (this.checked) {
        $(
          ".box-empresa[data-cidade='" + $(this).attr('data-cidade') + "']",
        ).show();
        $(
          $(
            ".box-empresa[data-cidade='" + $(this).attr('data-cidade') + "']",
          ).find('input'),
        ).prop('checked', true);
      } else {
        $(
          ".box-empresa[data-cidade='" + $(this).attr('data-cidade') + "']",
        ).hide();
        $(
          $(
            ".box-empresa[data-cidade='" + $(this).attr('data-cidade') + "']",
          ).find('input'),
        ).prop('checked', false);
      }
    });

    $('.local-todos').change(function () {
      $('#ddlCluster option').eq(0).prop('selected', true);
      if (this.checked) {
        $('.local').prop('checked', true);
        $('.empresas').prop('checked', true);
        $('.box-empresa').show();
      } else {
        $('.local').prop('checked', false);
        $('.empresas').prop('checked', false);
        $('.box-empresa').hide();
      }
    });

    $('.local-todos-cluster').prop('checked', true);
    $('.local-cluster').prop('checked', true);
    $('.local-cluster').change(function () {
      //$('#ddlCluster option').eq(0).prop('selected', true);
      if (this.checked) {
        $(
          ".box-empresa-cluster[data-cidade='" +
          $(this).attr('data-cidade') +
          "']",
        ).show();
        $(
          $(
            ".box-empresa-cluster[data-cidade='" +
            $(this).attr('data-cidade') +
            "']",
          ).find('input'),
        ).prop('checked', false);
      } else {
        $(
          ".box-empresa-cluster[data-cidade='" +
          $(this).attr('data-cidade') +
          "']",
        ).hide();
        $(
          $(
            ".box-empresa-cluster[data-cidade='" +
            $(this).attr('data-cidade') +
            "']",
          ).find('input'),
        ).prop('checked', false);
      }
    });

    $('.local-todos-cluster').change(function () {
      //$('#ddlCluster option').eq(0).prop('selected', true);
      if (this.checked) {
        $('.local-cluster').prop('checked', true);
        $('.empresas-cluster').prop('checked', false);
        $('.box-empresa-cluster').show();
      } else {
        $('.local-cluster').prop('checked', false);
        $('.empresas-cluster').prop('checked', false);
        $('.box-empresa-cluster').hide();
      }
    });

    $('.empresas-filtro-todos').change(function () {
      if (this.checked) {
        $('.empresas-filtro').prop('checked', true);
      } else {
        $('.empresas-filtro').prop('checked', false);
      }
    });

    $('.segmentos-filtro-todos').change(function () {
      if (this.checked) {
        $('.segmentos-filtro').prop('checked', true);
      } else {
        $('.segmentos-filtro').prop('checked', false);
      }
    });

    $('#table-line-todos').change(function () {
      if (this.checked) {
        $('.table-line').prop('checked', true);
      } else {
        $('.table-line').prop('checked', false);
      }
    });
    $('#table-spinner').hide();

    if (importacaoData.length == 0) {
      $('#tblImportacao').hide();
    } else {
      $('#tblImportacao').show();
    }
    if (precosRelatorio.length == 0) {
      $('#tblRelatorio').hide();
    }

    $(document).mousedown(function (event) {
      var $target = $(event.target);

      if (
        !$target.closest('.dropdown-dialog').length &&
        $('.dropdown-dialog').is(':visible')
      ) {
        $('.dropdown-dialog').fadeOut('fast');
      }
    });
  });

  async function SelectedTab(name) {
    if (name == 'cluster') {
      $('.local-todos').prop('checked', false);
      $('.local-todos').click();
      BuscaClusters();
    }
  }

  async function BuscaClusters(reset = true) {
    const res = await api.get('/empresa/v1/cluster');

    if (res.data.results != null) {
      res.data.results = res.data.results.filter((obj) => obj.status == 'A');
      for (var a = 0; a < res.data.results.length; a++) {
        res.data.results[a].childs = [];
        const res2 = await api.get(
          '/empresa/v1/clusterEmpresa/' + res.data.results[a].seqcluster,
        );

        if (res2.data.results != null) {
          res.data.results[a].childs = res2.data.results.filter(
            (obj) => obj.status == 'A',
          );
        }

        if (reset) {
          setTimeout(function () {
            $('.box-cluster-empresa').hide();
          }, 1);
        }
      }

      setClusters(res.data.results);
    }
  }

  async function ShowClusterEmpresas(id) {
    $('[data-id="' + id + '"]').slideToggle();
  }

  async function OpenModalAddEmpresa(id) {
    currentCluster = id;
    window.$('#modal-add').modal('show');
  }

  async function OpenModalAddCluster() {
    $('#txtClusterName').val('');
    currentCluster = 0;
    window.$('#modal-add-cluster').modal('show');
  }

  async function AddCluster() {
    const res = await api.post('/empresa/v1/cluster_create', {
      seqcluster: currentCluster,
      descricao: $('#txtClusterName').val(),
      status: 'A',
      usuario: '' + token.userName,
    });
    if (res.data.codResult != 1) {
      window.$('#modal-add-cluster').modal('hide');
      ShowAlert('Cluster', res.data.msg);
    }

    BuscaClusters();
  }

  async function EditarCluster(seqcluster, descricao) {
    currentCluster = seqcluster;
    $('#txtClusterName').val(descricao);
    window.$('#modal-add-cluster').modal('show');
  }

  async function AddEmpresaCluster() {
    var empresas = $('input[name=ckbEmpresa2]:checked');

    empresas.each(async function (item) {
      const res = await api.post('/empresa/v1/clusterEmpresa_create', {
        seqcluster: currentCluster,
        nroempresa: $(this).val(),
        status: 'A',
        usuario: '' + token.userName,
      });
      if (res.data.codResult != 1) {
        ShowAlert('Cluster', res.data.msg);
      }
      window.$('#modal-add').modal('hide');
    });

    BuscaClusters(false);
  }

  async function RemoverCluster(seqcluster, descricao) {
    const res = await api.post('/empresa/v1/cluster_create', {
      seqcluster: seqcluster,
      nroempresa: descricao,
      status: 'I',
      usuario: '' + token.userName,
    });
    if (res.data.codResult != 1) {
      window.$('#modal-add').modal('hide');
      ShowAlert('Cluster', res.data.msg);
    }

    BuscaClusters(false);
  }

  async function RemoveEmpresaCluster(id) {
    var empresas = $('input[name=' + id + 'ckb]:checked');
    currentCluster = id;

    empresas.each(async function (item) {
      const res = await api.post('/empresa/v1/clusterEmpresa_create', {
        seqcluster: currentCluster,
        nroempresa: $(this).val(),
        status: 'I',
        usuario: '' + token.userName,
      });
      if (res.data.codResult != 1) {
        window.$('#modal-add').modal('hide');
        ShowAlert('Cluster', res.data.msg);
      }
    });

    BuscaClusters(false);
  }

  async function SetClusterSelected() {
    var seqcluster = $('#ddlCluster').val();
    if (seqcluster != 0) {
      var currentClusterEmpresas = clusters.filter(
        (obj) => obj.seqcluster == seqcluster,
      );

      $('.empresas').parent().parent().parent().hide();
      $('.empresas').prop('checked', false);
      $('.local').prop('checked', false);
      $('.local-todos').prop('checked', false);
      for (var i = 0; i < currentClusterEmpresas[0].childs.length; i++) {
        $(
          'input[data-empresaid=' +
          currentClusterEmpresas[0].childs[i].nroempresa +
          ']',
        )
          .parent()
          .parent()
          .parent()
          .show();
        $(
          'input[data-empresaid=' +
          currentClusterEmpresas[0].childs[i].nroempresa +
          ']',
        ).prop('checked', true);
      }
    } else {
      $('.empresas').parent().parent().parent().show();
      $('.empresas').prop('checked', true);
      $('.local').prop('checked', true);
      $('.local-todos').prop('checked', true);
    }
  }

  async function BuscaEmpresas() {
    const res = await api.get('/empresa/listaempresa/');
    var result = null;

    if (res.data.results != null) {
      res.data.results.sort(dynamicSort('cidade'));
      setLocais(distinct(res.data.results, 'cidade'));
      res.data.results.sort(dynamicSort('nroempresa'));
      setEmpresas(res.data.results);
    }
  }

  async function BuscaEmbalagens() {
    const res = await api.get(
      '/produto/v1/embalagem/' + currentProduto.seqfamilia,
    );
    var result = null;

    if (res.data.results != null) {
      setEmbalagens(res.data.results);

      $('.card-embalagem').show();
      $('.card-relacionados').show();
    }
  }

  async function BuscaProduto(event) {
    if (event.key === 'Enter') {
      try {
        const res = await api.get(
          '/produto/v1/produto/' +
          document.getElementById('txtCodigoProduto').value,
        );

        if (res.data.results != null) {
          SetSelectedProduto(res.data.results[0]);
          BuscaEmbalagens();
          BuscaProdutosRelacionados();
          setTimeout(function () {
            $('.embalagens').val('');
          }, 100);
        }
      } catch (ex) {
        ClearFields();
        alert('Nenhum produto foi localizado. ');
        console.log(ex);
      }
    }
  }

  async function BuscaProdutosRelacionados() {
    const res = await api.get(
      '/produto/v1/produtorelacionado/' +
      document.getElementById('txtCodigoProduto').value,
    );

    if (res.data.results != null) {
      setProdutosRelacionados(res.data.results);
    }
  }

  async function Salvar() {
    setCurrentBatchId(null)
    var empresasStr = '';
    var empresas = $('input[name=ckbEmpresa]:checked');
    var embalagensTemp = $('.embalagens');
    var embalagens = [];
    let noMonirotedList = [];
    const segments = selectedSegments.join(',');

    embalagensTemp.each(function (i) {
      if ($(embalagensTemp[i]).val() !== '') {
        embalagens.push({
          nomeEmbalagem: $(embalagensTemp[i]).attr('data-nomecompleto'),
          qtdembalagem: $(embalagensTemp[i]).attr('data-qtdembalagem'),
          preconovo: parseFloat($(embalagensTemp[i]).val())
        });
      }
    });

    empresas.each(function (i) {
      empresasStr += $(empresas[i]).val() + ',';
    });
    empresasStr = empresasStr.slice(0, -1);

    if (segments.length <= 0) return toast.warning('Selecione ao menos um segmento.');

    if (moment(new Date(dtaAgendamento)).format('yyyy-MM-DD') < moment(new Date()).format('yyyy-MM-DD'))
      return toast.warning('Data de agendamento retroativa não é permitida.');

    if (currentProduto == null) return toast.warning('Selecione o produto.');

    if (embalagens.length <= 0) return toast.warning('Informe o preço de ao menos uma embalagem.');

    if (empresas.length <= 0) return toast.warning('Selecione ao menos uma empresa.');

    try {
      loading.setLoading(true)
      const requestData = {
        data: embalagens.map((e) => ({
          seqproduto: currentProduto.seqproduto,
          embalagem: e.qtdembalagem,
          preconovo: e.preconovo,
          dtaagendamento: moment(dtaAgendamento).format('DD/MM/yyyy'),
          chapaUsuario: '' + token.userName,
          nroempresa: empresasStr,
          motivo: 0,
          nrosegmento: segments,
        }))
      };

      const response = await api.post('/produto/v1/precomonitorado_v2', requestData);

      const result = response.data;
      let responseMessage = `<b>ID Lote:</b> ${result.id_lote}<br/><br/>`;
      setCurrentBatchId(result.id_lote)
      result.resultados.forEach((r) => {
        // Buscar descrição da embalagem "ex: CX-12.000"
        const foundEmbalagemGivenTheResult = embalagens.find(e => parseFloat(e.qtdembalagem) === r.embalagem)

        const color =
          r.codResult === 0 || r.codResult === 1
            ? 'text-green'
            : r.codResult === 2
              ? 'text-secondary'
              : 'text-red';

        responseMessage += `
          <div class="mb-2">
            <b>Embalagem:</b> ${foundEmbalagemGivenTheResult.nomeEmbalagem} - 
            <span class="${color}">
              <b>${r.msg}</b>
            </span>
          </div>
        `

        if (r.codResult === 2) {
          noMonirotedList.push({
            codproduto: r.seqproduto,
            qtdembalagem: r.embalagem,
            preconovo: r.preconovo,
            status: r.status,
            nrosegmentos: segments,
            nroempresas: empresasStr,
            dtahoraagenda: moment(dtaAgendamento).format('DD/MM/yyyy')
          });
        }
      });

      setProdutoNaoMonitoradoList(noMonirotedList);
      ShowAlert('Resultado da Alteração de Preços', responseMessage);
      loading.setLoading(false)

      if (result.errors === 0) ClearFields();

    } catch (error) {
      console.error(error);
      loading.setLoading(false)
      toast.error('Erro ao processar as alterações de preço.');
    }
  }

  function FindEmpresa(id) {
    var toReturn = null;
    empresas.forEach(function (item, a) {
      if (parseInt(empresas[a].nroempresa) == parseInt(id)) {
        toReturn = empresas[a].nome_reduzido;
      }
    });

    return toReturn;
  }

  async function EmbalagemChange(itemName) {
    if ($('#' + itemName).val() == '0.00') {
      $('#' + itemName).val('');
    }
  }

  async function Filtrar(url = null) {
    try {
      $('#table-spinner').show();
      var produto = $('#txtProdutoPesquisa').val();
      var empresasStr = '';
      var segmentosStr = '';
      var empresas = $('input[name=ckbEmpresaFiltro]:checked');
      var segmentos2 = $('input[name=ckbSegmentoFiltro]:checked');

      empresas.each(function (i) {
        empresasStr += $(empresas[i]).val() + ',';
      });
      empresasStr = empresasStr.slice(0, -1);

      segmentos2.each(function (i) {
        segmentosStr += $(segmentos2[i]).val() + ',';
      });
      segmentosStr = segmentosStr.slice(0, -1);

      if (empresasStr == '') empresasStr = '0';

      if (segmentosStr == '') segmentosStr = '0';

      if (produto == '') produto = '0';

      var res = null;
      if (url == null) {
        res = await api.get(
          '/produto/v1/preco_monitorado_api_get/' +
          moment(startDate).format('DD-MM-yyyy') +
          '/' +
          moment(endDate).format('DD-MM-yyyy') +
          '/' +
          empresasStr +
          '/' +
          segmentosStr +
          '/' +
          produto +
          '/' +
          $('#cboStatus').val(),
        );
      } else {
        res = await api.get(url.replace(api.baseURL, ''));
      }

      if (res.data.results != null) {
        if (res.data.results.length > 0) {
          for (var i = 0; i < res.data.results.length; i++) {
            segmentos.forEach(function (item, a) {
              if (
                parseInt(segmentos[a].nrosegmento) ==
                parseInt(res.data.results[i].nrosegmento)
              ) {
                res.data.results[i].nomesegmento = segmentos[a].descsegmento;
              }
            });

            res.data.results[i].nomeempresa = FindEmpresa(
              res.data.results[i].nroempresa,
            );
          }

          $('#btnNext').attr('data-url', res.data.next);
          $('#btnPrev').attr('data-url', res.data.previous);

          if ($('#btnNext').attr('data-url') == null) {
            $('#btnNext').hide();
          } else {
            $('#btnNext').show();
          }

          if ($('#btnPrev').attr('data-url') == null) {
            $('#btnPrev').hide();
          } else {
            $('#btnPrev').show();
          }
          setPrecosRelatorio(res.data.results);
          $('#tblRelatorio').show();
          $('#table-spinner').hide();
        } else {
          setPrecosRelatorio([]);
          toast.error('Nenhuma registro foi localizado');
        }
      }
    } catch (ex) {
      alert('Ocorreu um erro ao processar os dados.');
      console.log(ex);
    }
  }

  async function ProximaPagina() {
    $('html, body, #tblRelatorio .card-body').animate(
      { scrollTop: 0 },
      'fast',
      function () {
        Filtrar($('#btnNext').attr('data-url'));
      },
    );
  }

  async function PaginaAnterior() {
    $('html, body, #tblRelatorio .card-body').animate(
      { scrollTop: 0 },
      'fast',
      function () {
        Filtrar($('#btnPrev').attr('data-url'));
      },
    );
  }

  async function AcaoSelecionada() {
    if ($('#ddlAcao').val() == 'Cancelar') {
      const options = {
        title: 'Cancelamento',
        message: 'Deseja realmente cancelar os registros selecionados?',
        buttons: [
          {
            label: 'Sim',
            onClick: () => Cancelar(),
          },
          {
            label: 'Não',
            onClick: () => ResetAcao(),
          },
        ],
      };

      confirmAlert(options);
    }
  }

  async function ResetAcao() {
    $('#ddlAcao option').eq(0).prop('selected', true);
    $('.table-line').prop('checked', false);
  }

  async function Cancelar() {
    window.respMsg = '';
    $('.table-line').each(
      await async function (i) {
        if ($(this).is(':checked')) {
          var dtaagendamento = precosRelatorio[$(this).val()].dtaagendamento;
          try {
            dtaagendamento = precosRelatorio[
              $(this).val()
            ].dtaagendamento.replace(' 00:00:00', '');
          } catch { }

          const res = await api.post('/produto/v1/precomonitorado/cancelar/', {
            seqproduto: precosRelatorio[$(this).val()].seqproduto,
            embalagem: precosRelatorio[$(this).val()].embalagem,
            preconovo: precosRelatorio[$(this).val()].preconovo,
            dtaagendamento: dtaagendamento,
            chapaUsuario: precosRelatorio[$(this).val()].chapaUsuario,
            nroempresa: precosRelatorio[$(this).val()].nroempresa,
            motivo: precosRelatorio[$(this).val()].motivo,
            nrosegmento: precosRelatorio[$(this).val()].nrosegmento,
          });

          if (res.data.codResult == 0) {
            window.respMsg +=
              precosRelatorio[i].seqproduto +
              ' ' +
              precosRelatorio[i].descricao +
              ": <span class='text-red'>" +
              res.data.msg +
              '</span><br/>';
          } else {
            window.respMsg +=
              precosRelatorio[i].seqproduto +
              ' ' +
              precosRelatorio[i].descricao +
              ": <span class='text-green'>" +
              res.data.msg +
              '</span><br/>';
          }

          ShowAlert('Atenção', window.respMsg);
        }
      },
    );

    ResetAcao();

    Filtrar();
  }

  function SetSelectedProduto(p) {
    currentProduto = p;
    document.getElementById('txtDescricaoProduto').value =
      currentProduto.descreduzida;
  }

  function ClearFields() {
    document.getElementById('txtCodigoProduto').value = '';
    document.getElementById('txtDescricaoProduto').value = '';
    setEmbalagens([]);
    $('.card-embalagem').hide();
    $('.card-relacionados').hide();
    currentProduto = null;
  }

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  function distinct(array, field) {
    return array.reduce((accumulator, current) => {
      if (!accumulator.includes(current[field])) {
        accumulator.push(current[field]);
      }
      return accumulator;
    }, []);
  }

  function findSegmentoByNro(array, id) {
    return array.find((element) => {
      return element.nrosegmento === id;
    });
  }

  async function BtnEmpresasFiltroClicked() {
    window.$('#boxEmpresas3').fadeIn('fast');
  }

  async function BtnSegmentoFiltroClicked() {
    window.$('#boxSegmentos2').fadeIn('fast');
  }
  async function Closemodal() {
    window.$('.modal').modal('hide');
  }

  async function handleExportBatchDetails(batchId) {
    try {
      setIsExportingCSV(true)
      const response = await api.get("produto/v1/exporta_lote_importacao/", {
        params: {
          id_lote: batchId
        },
        responseType: "blob"
      })

      // Access headers.content-disposition to get the file name
      const contentDisposition = response.headers["content-disposition"];

      let fileName = `log_importacao_lote_${batchId}.xlsx`;

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);

        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

      setIsExportingCSV(false)
    } catch (error) {
      setIsExportingCSV(false)
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Falha ao exportar os detalhes do lote.");
      }
    }
  }

  function formatDate(dateString) {
    const [year, month, day] = dateString.split('-')

    return `${day}/${month}/${year}`;
  }

  // ---------------------------------------------------------------------------

  const handleToggleAllSegments = (checked) => {
    if (checked) {
      setSelectedSegments(segmentos.map((s) => s.nrosegmento));
    } else {
      setSelectedSegments([]);
    }
  };

  const handleInvertSelectedSegments = () => {
    const invertidos = segmentos
      .filter((s) => !selectedSegments.includes(s.nrosegmento))
      .map((s) => s.nrosegmento);
    setSelectedSegments(invertidos);
  };

  const handleSelectSegment = (nrosegmento, checked) => {
    if (checked) {
      setSelectedSegments([...selectedSegments, nrosegmento]);
    } else {
      setSelectedSegments(selectedSegments.filter((id) => id !== nrosegmento));
    }
  };

  return (
    <Fragment>
      <div className="content-header">
        <h1 style={{ marginLeft: 20 }}>Alteração de Preço Beta</h1>
      </div>

      <Container fluid className="content">
        <Tabs
          defaultActiveKey="preco"
          onSelect={(firstTab, lastTab) => {
            SelectedTab(`${firstTab}`)
            setProdutoNaoMonitoradoList([])
          }}
        >
          <Tab eventKey="preco" title="Preço">
            <div id="box-preco-manual">
              <Card >
                <Card.Body>
                  <Row>
                    <Col sm={2}>
                      <Card style={{ height: '300px' }}>
                        <Card.Body
                          className="card-body"
                          style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                        >
                          <h4 className="text-md">Segmentos</h4>
                          <Row id="boxSegmentos" style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>
                            <Form>
                              <Col sm={12}>
                                <Form.Check
                                  type="checkbox"
                                  id="ckbSegTodos"
                                  label="Marcar Todos"
                                  className="segmento-todos"
                                  checked={selectedSegments.length === segmentos.length}
                                  onChange={(e) => handleToggleAllSegments(e.target.checked)}
                                />
                              </Col>
                              <Col sm={12}>
                                <Form.Check
                                  type="checkbox"
                                  id="ckbSegInvert"
                                  label="Inverter Seleção"
                                  className="segmento-inverter"
                                  onChange={handleInvertSelectedSegments}
                                />
                              </Col>
                              {segmentos.map((item, index) => (
                                <Col sm={12} key={index}>
                                  <Form.Check
                                    type="checkbox"
                                    id={`seg-${item.nrosegmento}`}
                                    label={item.descsegmento}
                                    className="segmento-preco"
                                    checked={selectedSegments.includes(item.nrosegmento)}
                                    onChange={(e) =>
                                      handleSelectSegment(item.nrosegmento, e.target.checked)
                                    }
                                  />
                                </Col>
                              ))}
                            </Form>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col sm={2}>
                      <Card style={{ height: '300px' }}>
                        <Card.Body
                          style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                        >
                          <Row>
                            <Col sm={12}>
                              <div className="form-group">
                                <label>Data do agendamento</label>
                                <DatePicker
                                  selected={dtaAgendamento}
                                  onChange={(date) =>
                                    setDtaAgendamento(date)
                                  }
                                  className="form-control "
                                  locale="pt"
                                  dateFormat="dd/MM/yyyy"
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={12}>
                              <div className="form-group">
                                <label>Código do Produto</label>
                                <input
                                  id="txtCodigoProduto"
                                  className="form-control"
                                  onKeyUp={(event) => BuscaProduto(event)}
                                  placeholder="Entre com o código do produto"
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={12}>
                              <div className="form-group">
                                <label>Descrição</label>
                                <input
                                  disabled="disabled"
                                  id="txtDescricaoProduto"
                                  className="form-control"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col sm={6}>
                      <Card className="card card-embalagem" style={{ height: '300px' }}>
                        <Card.Body
                          className="card-body"
                          style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                        >
                          <h4 className="text-md">Embalagens</h4>

                          <Row id="boxEmbalagens" style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>
                            {embalagens.map((item, index) => (
                              <Col sm={4} className="mb-2" key={index}>
                                <Row>
                                  <Col sm={6} className="text-right pt-2">
                                    {item.embalagem + ' - ' + item.qtdembalagem}
                                  </Col>
                                  <Col sm={6}>
                                    <CurrencyInput
                                      id={'embalagem' + index}
                                      type="search"
                                      allowempty="true"
                                      allowleadingzeroes="false"
                                      onBlur={() =>
                                        EmbalagemChange('embalagem' + index)
                                      }
                                      className="form-control embalagens"
                                      data-qtdembalagem={item.qtdembalagem}
                                      data-nomecompleto={
                                        item.embalagem +
                                        ' - ' +
                                        item.qtdembalagem
                                      }
                                      placeholder="R$ 0,00"
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            ))}
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>

                    <Col sm={2}>
                      <Card className="card-relacionados" style={{ height: '300px' }}>
                        <Card.Body
                          style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
                        >
                          <h4 className="text-md">Produtos Relacionados</h4>
                          <Row style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>
                            {produtosRelacionados.length > 0 ? (
                              produtosRelacionados.map((item, index) => (
                                <Col sm={12} key={index}>
                                  {item.seqproduto + ' - ' + item.desccompleta}
                                  <hr />
                                </Col>
                              ))
                            ) : (
                              <Col
                                sm={12}
                                className={
                                  'text-sm ' +
                                  (produtosRelacionados.length == 0
                                    ? ' d-block'
                                    : ' d-none')
                                }
                              >
                                Nenhum produto relacionado
                              </Col>
                            )}
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  <Card>
                    <Card.Body>
                      <h4 className="text-md">Empresas</h4>
                      <hr />
                      <Row>
                        <Col sm={3}>
                          <select
                            id="ddlCluster"
                            className="form-control mb-3"
                            onChange={() => {
                              SetClusterSelected();
                            }}
                          >
                            <option value="0">Selecione um cluster</option>
                            {clusters.map((item, index) => (
                              <option key={index} value={item.seqcluster}>
                                {item.descricao}
                              </option>
                            ))}
                          </select>
                          <Row id="boxLocais" className="row">
                            <Col sm={12} className="col-sm-12">
                              <div className="form-check">
                                <label className="form-check-label">
                                  <input
                                    className="form-check-input local-todos"
                                    type="checkbox"
                                  />
                                  &nbsp; Marcar Todos
                                </label>
                              </div>
                            </Col>
                            {locais.map((item, index) => (
                              <div className="col-sm-12" key={index}>
                                <div className="form-check">
                                  <label className="form-check-label">
                                    <input
                                      className="form-check-input local"
                                      data-cidade={item}
                                      value={item}
                                      type="checkbox"
                                    />
                                    &nbsp;&nbsp;
                                    {item}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </Row>
                        </Col>

                        <Col sm={9}>
                          <Row
                            id="boxEmpresas"
                            className="bg-gray-light p-3 rounded"
                          >
                            {empresas.map((item, index) => (
                              <Col
                                sm={3}
                                className="box-empresa"
                                data-cidade={item.cidade}
                                key={index}
                              >
                                <div className="form-check">
                                  <label className="form-check-label">
                                    <input
                                      name="ckbEmpresa"
                                      className="form-check-input empresas"
                                      data-cidade={item.cidade}
                                      data-empresaid={item.nroempresa}
                                      value={item.nroempresa}
                                      type="checkbox"
                                    />
                                    {item.nome_reduzido}
                                  </label>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      </Row>

                      <Button
                        type="button"
                        variant='primary'
                        className="mt-3"
                        style={{ float: 'right' }}
                        onClick={() => Salvar()}
                        disabled={loading.isLoading}
                      >

                        {loading.isLoading ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              className="me-2"
                            /> {" "}
                            Salvar
                          </>
                        ) : (
                          <>
                            Salvar
                          </>
                        )}
                      </Button>
                    </Card.Body>
                  </Card>

                  <Row>
                    <Col sm={2} style={{ display: 'flex' }}></Col>
                  </Row>
                </Card.Body>
              </Card>
            </div>
          </Tab>

          <Tab eventKey="import" title="Importação V2">
            <ImportTab />
          </Tab>

          <Tab eventKey="log_import" title="Histórico de Importação" >
            <HistoryImportTab />
          </Tab>

          <Tab eventKey="cancelamento" title="Cancelamento" style={{ background: 'white' }}>
            <Card>
              <Card.Body>
                <div className="box-pesquisa bg-gray-light p-3 rounded mb-3 border">
                  <Row>
                    <Col sm={1}>
                      <label>Data inicial</label>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        className="form-control"
                        locale="pt"
                        dateFormat="dd/MM/yyyy"
                      />
                    </Col>

                    <Col sm={1}>
                      <label>Data final</label>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        className="form-control"
                        locale="pt"
                        dateFormat="dd/MM/yyyy"
                      />
                    </Col>
                    <Col sm={2}>
                      <label>Empresas</label>
                      <div className="dropdown">
                        <Button
                          type="button"
                          className="bg-white w-100 text-left border"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={() => {
                            BtnEmpresasFiltroClicked();
                          }}
                        >
                          Selecione
                        </Button>

                        <Row
                          id="boxEmpresas3"
                          className="bg-white border p-3 rounded dropdown-dialog"
                          style={{
                            zIndex: 99999,
                            position: 'absolute',
                            width: 660,
                            height: 350,
                            overflow: 'auto',
                            marginLeft: 0,
                            boxShadow: '0 8px 9px 0px rgb(0 0 0 / 30%)',
                          }}
                        >
                          <Col
                            sm={6}
                            style={{
                              paddingLeft: '27px',
                              paddingBottom: '15px',
                              paddingTop: '8px',
                            }}
                          >
                            <label className="form-check-label">
                              <input
                                className="form-check-input empresas-filtro-todos"
                                type="checkbox"
                              />
                              Marcar todos
                            </label>
                          </Col>
                          <Col
                            sm={6}
                            style={{
                              paddingLeft: '27px',
                              paddingBottom: '15px',
                              paddingTop: '8px',
                            }}
                          >
                            <label className="form-check-label">
                              <input
                                name="ckbEmpresaFiltroInverter"
                                className="form-check-input empresas-filtro-inverter"
                                type="checkbox"
                              />
                              Inverter seleção
                            </label>
                          </Col>
                          {empresas.map((item, index) => (
                            <Col
                              sm={3}
                              className="box-empresa-filtro"
                              data-cidade={item.cidade}
                              key={index}
                            >
                              <div className="form-check">
                                <label className="form-check-label">
                                  <input
                                    name="ckbEmpresaFiltro"
                                    className="form-check-input empresas-filtro"
                                    data-cidade={item.cidade}
                                    data-empresaid={item.nroempresa}
                                    value={item.nroempresa}
                                    type="checkbox"
                                  />
                                  {item.nome_reduzido}
                                </label>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </Col>
                    <Col sm={2}>
                      <label>Segmento</label>
                      <div className="dropdown">
                        <Button
                          type="button"
                          className="bg-white w-100 text-left border"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={() => {
                            BtnSegmentoFiltroClicked();
                          }}
                        >
                          Selecione
                        </Button>

                        <Row
                          id="boxSegmentos2"
                          className="bg-white border p-3 rounded dropdown-dialog"
                          style={{
                            zIndex: 99999,
                            position: 'absolute',
                            width: 660,
                            height: 150,
                            overflow: 'auto',
                            marginLeft: 0,
                            boxShadow: '0 8px 9px 0px rgb(0 0 0 / 30%)',
                          }}
                        >
                          <Col
                            sm={6}
                            className="col-6 "
                            style={{
                              paddingLeft: '27px',
                              paddingBottom: '15px',
                              paddingTop: '8px',
                            }}
                          >
                            <label className="form-check-label">
                              <input
                                className="form-check-input segmentos-filtro-todos"
                                type="checkbox"
                              />
                              Marcar todos
                            </label>
                          </Col>
                          <Col
                            sm={6}
                            className="col-6 "
                            style={{
                              paddingLeft: '27px',
                              paddingBottom: '15px',
                              paddingTop: '8px',
                            }}
                          >
                            <label className="form-check-label">
                              <input
                                name="ckbSegmentosFiltroInverter"
                                className="form-check-input segmentos-filtro-inverter"
                                type="checkbox"
                              />
                              Inverter seleção
                            </label>
                          </Col>
                          {segmentos.map((item, index) => (
                            <Col
                              sm={4}
                              className="box-emp resa"
                              data-cidade={item.cidade}
                              key={index}
                            >
                              <div className="form-check">
                                <label className="form-check-label">
                                  <input
                                    name="ckbSegmentoFiltro"
                                    className="form-check-input segmentos-filtro"
                                    value={item.nrosegmento}
                                    type="checkbox"
                                  />
                                  {item.descsegmento}
                                </label>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </Col>
                    <Col sm={2}>
                      <label>Status</label>
                      <select id="cboStatus" className="form-control">
                        <option value="T">Todos</option>
                        <option value="P">Pedente</option>
                        <option value="X">Alterados </option>
                        <option value="I">Inativos</option>
                        <option value="C">Cancelado</option>
                      </select>
                    </Col>

                    <Col sm={2}>
                      <label>Produto</label>
                      <input
                        id="txtProdutoPesquisa"
                        type="text"
                        className="form-control"
                        placeholder="Código do produto"
                      />
                    </Col>

                    <Col sm={2}>
                      <Button
                        type='button'
                        variant='primary'
                        style={{ marginTop: 31 }}
                        onClick={() => Filtrar()}
                      >
                        Filtrar
                      </Button>
                    </Col>
                  </Row>
                </div>

                <div
                  id="table-spinner"
                  className="mb-3"
                  style={{
                    textAlign: 'center',
                    position: 'absolute',
                    zIndex: '9',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255,255,255,.5)',
                    paddingTop: '110px',
                  }}
                >
                  <Spinner animation="border" variant="primary" />
                </div>
                <Card id="tblRelatorio">
                  <div
                    className=""
                    style={{ overflow: 'auto', maxHeight: '50vh' }}
                  >
                    <table
                      id="tblRelatorio"
                      className="table table-striped table-hover tabl e-sm  "
                    >
                      <thead className="">
                        <tr>
                          <th scope="col" style={{ textAlign: 'center' }}>
                            <input
                              id="table-line-todos"
                              type="checkbox"
                              value=""
                            />
                          </th>
                          <th scope="col">Produto</th>
                          <th scope="col">Embalagem</th>
                          <th scope="col">Preço Novo</th>
                          <th scope="col">Agendamento</th>
                          <th scope="col">Usuário</th>
                          <th scope="col">Empresa</th>
                          <th scope="col">Segmento</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>

                      <tbody id="table-body">
                        {precosRelatorio.map((item, index) => (
                          <tr className="table-fields" key={index}>
                            <td scope="row" style={{ textAlign: 'center' }}>
                              <input
                                className="table-line"
                                type="checkbox"
                                value={index}
                              />
                            </td>
                            <td>{item.seqproduto + ' - ' + item.descricao}</td>
                            <td>{item.qtdembalagem}</td>
                            <td>
                              R$
                              {parseFloat(item.preconovo)
                                .toFixed(2)
                                .toString()
                                .replace('.', ',')}
                            </td>
                            <td>{item.dtaagendamento}</td>
                            <td>{item.chapaUsuario}</td>
                            <td>{item.nomeempresa}</td>
                            <td>{item.nomesegmento}</td>
                            <td>{item.status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <Row>
                    <Col sm={3} className="col-3">
                      <div
                        className=" mt-3 mb-3"
                        style={{ float: 'left', marginLeft: '20px' }}
                      >
                        <select
                          id="ddlAcao"
                          className="form-control"
                          onChange={() => AcaoSelecionada()}
                        >
                          <option value="Cancelar">Ações</option>
                          <option value="Cancelar">Cancelar</option>
                        </select>
                      </div>
                    </Col>
                    <Col sm={9}>
                      <div style={{ float: 'right', marginRight: '15px' }}>
                        <nav className="mt-3">
                          <ul className="pagination">
                            <li className="page-item">
                              <Button
                                id="btnPrev"
                                className="page-link"
                                onClick={() => PaginaAnterior()}
                              >
                                Anterior
                              </Button>
                            </li>
                            <li className="page-item">
                              <Button
                                id="btnNext"
                                className="page-link"
                                onClick={() => ProximaPagina()}
                              >
                                Próximo
                              </Button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Card.Body>
            </Card>
          </Tab>

          <Tab eventKey="cluster" title="Cluster">
            <Card>
              <Card.Body>
                <h4>Cluster</h4>
                <p className="mb-3">Crie ou adicione empresas à um grupo.</p>
                <Button
                  type="button"
                  variant='primary'
                  size='sm'
                  className="mb-4"
                  title="Incluir empresa no cluster"
                  onClick={() => {
                    OpenModalAddCluster();
                  }}
                  data-toggle="tooltip"
                >
                  <i className="fa fa-plus fa-fw"></i> Novo Cluster
                </Button>
                <Row>
                  <Col sm={12}>
                    <TreeView
                      style={{
                        flexGrow: 1,
                      }}
                      defaultExpandIcon={<ChevronRightIcon />}
                      defaultCollapseIcon={<ExpandMoreIcon />}
                    >
                      <table className="table table-borde red">
                        <tbody>
                          {clusters.map((item, index) => (
                            <tr key={index}>
                              <td style={{ verticalAlign: 'middle' }}>
                                <div
                                  className="box-cluster cursor-pointer"
                                  role="button"
                                  onClick={() => {
                                    ShowClusterEmpresas('bxemp' + index);
                                  }}
                                >
                                  <i className="fa fa-layer-group fa-fw"></i>{' '}
                                  <b>{item.descricao}</b>
                                  <div style={{ marginLeft: 20 }}>
                                    {clusters[index].childs.length} empresa(s)
                                  </div>
                                </div>

                                <div
                                  className="box-cluster-empresa"
                                  data-id={'bxemp' + index}
                                >
                                  <div className=" mb-0 mt-3 bg-gray-light rounded p-3 ">
                                    <div className="controles mb-3">
                                      <Button
                                        variant='primary'
                                        size='sm'
                                        title="Incluir empresa no cluster"
                                        onClick={() => {
                                          OpenModalAddEmpresa(item.seqcluster);
                                        }}
                                        data-toggle="tooltip"
                                      >
                                        <i className="fa fa-plus fa-fw"></i>{' '}
                                        Nova Empresa
                                      </Button>
                                      <Button
                                        variant='secondary'
                                        size='sm'
                                        title="Remover empresa do cluster"
                                        onClick={() => {
                                          RemoveEmpresaCluster(item.seqcluster);
                                        }}
                                        data-toggle="tooltip"
                                        className="ml-3"
                                      >
                                        <i className="fa fa-times fa-fw"></i>{' '}
                                        Remover Selecionados
                                      </Button>
                                    </div>
                                    <Row>
                                      {clusters[index].childs.map(
                                        (item2, index2) => (
                                          <div key={index2} className="col-3">
                                            <label className="ml-5">
                                              <input
                                                className="form-check-input "
                                                name={item.seqcluster + 'ckb'}
                                                value={item2.nroempresa}
                                                type="checkbox"
                                              />
                                              {FindEmpresa(item2.nroempresa)}
                                            </label>
                                          </div>
                                        ),
                                      )}
                                    </Row>
                                  </div>
                                </div>
                              </td>
                              <td style={{ verticalAlign: 'top' }} width="190">
                                <Button
                                  variant='secondary'
                                  size='sm'
                                  title="Editar cluster"
                                  data-toggle="tooltip"
                                  onClick={() => {
                                    EditarCluster(
                                      item.seqcluster,
                                      item.descricao,
                                    );
                                  }}
                                >
                                  <i className="fa fa-edit fa-fw"></i> Editar
                                </Button>
                                <Button
                                  variant="secondary"
                                  size="sm"
                                  title="Excluir cluster"
                                  data-toggle="tooltip"
                                  className="ml-2"
                                  onClick={() => {
                                    RemoverCluster(
                                      item.seqcluster,
                                      item.descricao,
                                    );
                                  }}
                                >
                                  <i className="fa fa-times fa-fw"></i> Excluir
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </TreeView>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Tab>
        </Tabs>
      </Container>

      <div id="modal-alert" className="modal fade" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Modal title</h5>
              <Button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  Closemodal('show');
                }}
              >
                <span aria-hidden="true">&times;</span>
              </Button>
            </div>
            <div className="modal-body">
              <p>Ocorreu um erro durante a requisição.</p>
            </div>
            <div className="modal-footer">
              {produtoNaoMonitoradoList.length > 0 && (
                <Button
                  type='button'
                  variant='primary'
                  onClick={() => handleExportBatchDetails(currentBatchId)}
                  disabled={isExportingCSV}
                >
                  <i className='fa fa-file-download fa-fw' />
                  Exportar Não Monitorados
                </Button>
              )}
              <Button
                type="button"
                variant="secondary"
                data-dismiss="modal"
                onClick={() => {
                  Closemodal('show');
                }}
              >
                Fechar
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div id="modal-add" className="modal" role="dialog">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content " style={{ width: 900 }}>
            <div className="modal-header">
              <h5 className="modal-title">Adicionar empresa ao cluster</h5>
              <Button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  Closemodal('show');
                }}
              >
                <span aria-hidden="true">&times;</span>
              </Button>
            </div>
            <div className="modal-body">
              <div>
                <Row>
                  <Col sm={3}>
                    <Row id="boxLocais">
                      <Col sm={12}>
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              className="form-check-input local-todos-cluster"
                              type="checkbox"
                            />
                            &nbsp; Marcar Todos
                          </label>
                        </div>
                      </Col>
                      {locais.map((item, index) => (
                        <Col sm={12} key={index}>
                          <div className="form-check">
                            <label className="form-check-label">
                              <input
                                className="form-check-input local-cluster"
                                data-cidade={item}
                                value={item}
                                type="checkbox"
                              />
                              &nbsp;&nbsp;
                              {item}
                            </label>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>

                  <Col sm={9}>
                    <Row
                      id="boxEmpresas2"
                      className="bg-gray-light p-3 rounded"
                    >
                      {empresas.map((item, index) => (
                        <Col sm={3}
                          className="box-empresa-cluster"
                          data-cidade={item.cidade}
                          key={index}
                        >
                          <div className="form-check">
                            <label className="form-check-label">
                              <input
                                name="ckbEmpresa2"
                                className="form-check-input empresas-cluster"
                                data-cidade={item.cidade}
                                value={item.nroempresa}
                                type="checkbox"
                              />
                              {item.nome_reduzido}
                            </label>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                type="button"
                variant='primary'
                onClick={() => {
                  AddEmpresaCluster();
                }}
              >
                Incluir Selecionados
              </Button>
              <Button
                type="button"
                variant='secondary'
                data-dismiss="modal"
                onClick={() => {
                  Closemodal('show');
                }}
              >
                Fechar
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div id="modal-add-cluster" className="modal fade" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Adicionar novo cluster</h5>
              <Button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  Closemodal('show');
                }}
              >
                <span aria-hidden="true">&times;</span>
              </Button>
            </div>
            <div className="modal-body">
              <div>
                <input
                  type="text"
                  id="txtClusterName"
                  className="form-control"
                  placeholder="Digite o nome do cluster"
                />
              </div>
            </div>
            <div className="modal-footer">
              <Button
                type="button"
                variant='primary'
                onClick={() => {
                  AddCluster();
                }}
              >
                Incluir
              </Button>
              <Button
                type="button"
                variant='secondary'
                data-dismiss="modal"
                onClick={() => {
                  Closemodal('show');
                }}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
